import Vue from 'vue'

const copyTextToClipboard = async (text) => {
  const writeResult = await navigator.permissions.query({ name: 'clipboard-write' })
  if (writeResult.state === 'granted' || writeResult.state === 'prompt') {
    try {
      await navigator.clipboard.writeText(text)

      if (process.env.NODE_ENV !== 'production') {
        const clipboardContents = await navigator.clipboard.readText()
        Vue.logger.log(`Clipboard contents: ${clipboardContents}`)
      }

      return true
    } catch (error) {
      Vue.logger.error(error)
    }
  }
  return false
}

export { copyTextToClipboard }
